import { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'

export const kaapiOpenStackServersSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiOpenStackServers>(DataKeys.KaapiOpenStackServers),
  (kaapiOpenStackServers): any[] => kaapiOpenStackServers,
)
